import { render, staticRenderFns } from "./GeneralEditorComponent.vue?vue&type=template&id=d7add8ae"
import script from "./GeneralEditorComponent.vue?vue&type=script&lang=js"
export * from "./GeneralEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports